export enum LOCALES {
  EN = 'en-US',
  FR = 'fr-FR',
  ES = 'es-419',
  IT = 'it-IT',
  KR = 'ko-KR',
  UA = 'uk-UA',
  RU = 'ru-RU',
  CN = 'zh-Hans-CN',
}

export type LanguageSettingsMessage = Record<string, unknown> & {
  selectedLanguage: string;
};
